import React from 'react';
import { Container, Typography, Grid, Box, Button, Paper } from '@mui/material';
import { FaEnvelope, FaPhone, FaClock, FaTruck, FaWhatsapp } from 'react-icons/fa';

const ContactNew = () => {
  return (
    <Box sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)', py: { xs: 6, md: 10 } }}>
      {/* Use a full-width container feel with side padding to avoid narrow look */}
      <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 6, xl: 10 } }}>
        {/* Hero */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Box sx={{ position: 'relative', height: { xs: '250px', md: '350px' }, borderRadius: '24px', overflow: 'hidden', mb: 4, boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1600&q=90"
              alt="Pièces et accessoires pour camions professionnels"
              sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=1600&q=90'; }}
            />
            <Box sx={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(0,77,153,0.85) 0%, rgba(0,119,184,0.75) 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', px: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <FaTruck size={48} color="white" />
              </Box>
              <Typography variant="h1" sx={{ fontSize: { xs: '2.5rem', md: '3.5rem' }, fontWeight: 900, color: 'white', mb: 2, textShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>Contactez-nous</Typography>
              <Typography variant="h6" sx={{ fontSize: { xs: '1.1rem', md: '1.3rem' }, color: 'rgba(255,255,255,0.95)', maxWidth: 700, textAlign: 'center', fontWeight: 400, lineHeight: 1.6 }}>Spécialistes en pièces détachées et accessoires pour poids lourds</Typography>
            </Box>
          </Box>
        </Box>

        {/* Sections as wide pills */}
        <Grid container spacing={{ xs: 5, md: 7 }} direction="column" alignItems="center" justifyContent="center">
          {/* À propos */}
          <Grid item xs={12}>
            <Paper elevation={0} sx={{ width: '100%', mx: 'auto', maxWidth: { xs: '100%', xl: '1800px' }, p: { xs: 4, md: 8 }, borderRadius: { xs: '28px', md: '64px' }, bgcolor: 'white', boxShadow: '0 16px 48px rgba(15,23,42,0.10)' }}>
              <Typography variant="h4" sx={{ fontWeight: 900, color: '#0c4a6e', mb: 2 }}>À propos de nous</Typography>
              <Typography sx={{ color: '#334155', fontSize: { xs: '1rem', md: '1.125rem' }, lineHeight: 1.85, maxWidth: 1600 }}>
                ECOTIJ est une entreprise marocaine spécialisée à l'achat, négoce, importation et distribution des pièces accessoires, de carrosserie, pour véhicules, poids lourds, camions, remorques et véhicules utilitaires.
              </Typography>
            </Paper>
          </Grid>

          {/* Contact - matches the wireframe (left info, right WhatsApp button) */}
          <Grid item xs={12}>
            <Paper elevation={0} sx={{ width: '100%', mx: 'auto', maxWidth: { xs: '100%', xl: '1800px' }, p: { xs: 4, md: 8 }, borderRadius: { xs: '36px', md: '90px' }, bgcolor: 'white', boxShadow: '0 20px 60px rgba(15,23,42,0.10)' }}>
              <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }}>
                {/* Left: title + lines */}
                <Grid item xs={12} md={8} lg={9}>
                  <Typography variant="h4" sx={{ fontWeight: 900, color: '#0c4a6e', mb: { xs: 2, md: 3 } }}>Contactez-nous</Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <FaPhone size={20} color="#0077B8" />
                      <Typography sx={{ fontWeight: 700, color: '#0f172a' }}>06 61 83 77 26 / 06 65 04 92 99</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <FaEnvelope size={20} color="#0077B8" />
                      <Typography sx={{ fontWeight: 700, color: '#0f172a' }}>contact@ecotij.ma</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <FaClock size={20} color="#0077B8" />
                      <Box>
                        <Typography sx={{ fontWeight: 700, color: '#0f172a' }}>Lun–Ven: 8h30–13h00 / 14h–18h30</Typography>
                        <Typography sx={{ fontWeight: 700, color: '#0f172a' }}>Samedi: 8h30–13h00</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                {/* Right: WhatsApp button */}
                <Grid item xs={12} md={4} lg={3}>
                  <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
                    <Button
                      variant="contained"
                      onClick={() => window.open('https://wa.me/212665049299?text=Bonjour%2C%20je%20souhaite%20vous%20contacter%20concernant%20vos%20produits.', '_blank')}
                      startIcon={<FaWhatsapp color="#25D366" />}
                      sx={{ px: { xs: 4, md: 6 }, py: { xs: 1.5, md: 2 }, borderRadius: '999px', fontWeight: 800, textTransform: 'none', background: 'linear-gradient(90deg,#0077B8,#004D99)', color: 'white', boxShadow: '0 12px 24px rgba(0,119,184,0.30)', '&:hover': { background: 'linear-gradient(90deg,#004D99,#003A73)' } }}
                    >
                      Contacter via WhatsApp
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Localisation - replicate Home page style */}
          <Grid item xs={12} sx={{ width: '100%' }}>
            <Box sx={{ width: '100%', mx: 'auto', maxWidth: { xs: '100%', xl: '1800px' } }}>
              <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
                <Typography variant="overline" sx={{ color: '#00ACEA', fontWeight: 800, letterSpacing: '2px', fontSize: '0.875rem' }}>NOTRE LOCALISATION</Typography>
                <Typography variant="h4" sx={{ fontWeight: 900, color: '#0c4a6e', mt: 1, fontSize: { xs: '2rem', md: '2.25rem' } }}>Où nous trouver</Typography>
                <Typography sx={{ color: '#64748b', mt: 1, maxWidth: 700, mx: 'auto' }}>Retrouvez notre emplacement exact sur Google Maps et contactez-nous pour une visite.</Typography>
              </Box>
              <Box sx={{ borderRadius: '16px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.08)', border: '1px solid #e2e8f0' }}>
                <Box component="iframe" title="Notre localisation" src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3324.258376147363!2d-7.480193924303964!3d33.57264017334138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDM0JzIxLjUiTiA3wrAyOCczOS40Ilc!5e0!3m2!1sfr!2sma!4v1764444223074!5m2!1sfr!2sma" sx={{ width: '100%', height: { xs: 360, md: 500 }, border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
              </Box>
              <Box sx={{ textAlign: 'center', mt: 3 }}>
                <Button variant="contained" onClick={() => window.open('https://maps.app.goo.gl/FSqN2Ph9pMyZ5xLX6', '_blank')} sx={{ bgcolor: '#0077B8', fontWeight: 700, px: 4, py: 1.5, borderRadius: '40px' }}>Ouvrir dans Google Maps</Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactNew;
